import React from "react";
import ErrorBoundaryProvider from "./ErrorBoundaryProvider";
import ReactQueryProvider from "./ReactQueryProvider";
import ReactReduxProvider from "./ReactReduxProvider";
import ReactRouterProvider from "./ReactRouterProvider";

export default function AppProvider({ children }) {
    return (
        <ReactQueryProvider>
            <ReactReduxProvider>
                <ReactRouterProvider>
                    <ErrorBoundaryProvider>{children}</ErrorBoundaryProvider>
                </ReactRouterProvider>
            </ReactReduxProvider>
        </ReactQueryProvider>
    );
}
